// Ensures a user-entered URL opens as an absolute external link.
// "google.com" -> "https://google.com"; leaves http(s):// and mailto:/tel: untouched.
export const externalUrl = (url) => {
  if (!url) return url;
  const u = String(url).trim();
  if (!u) return u;
  if (/^(https?:|mailto:|tel:)/i.test(u)) return u;
  return "https://" + u.replace(/^\/+/, "");
};
